import { render, staticRenderFns } from "./ListaGrupoNotificacao.vue?vue&type=template&id=0b8e02c1"
import script from "./ListaGrupoNotificacao.vue?vue&type=script&lang=js"
export * from "./ListaGrupoNotificacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports